var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SalePointSelectField from '../CreateClassifiedForm/SalePointSelectField';
import { buildUpdateRequest, conditionOptions, selectableStatusOptions, } from '../../utils/classifiedFormOptions';
/**
 * Inline form used to edit an existing classified.
 *
 * Renders price, condition, status and pickup location,
 * and submits an update-request build from the current values.
 * */
var ClassifiedEditForm = function (props) {
    var values = props.values, salePoints = props.salePoints, isSaving = props.isSaving, error = props.error, onChange = props.onChange, onSubmit = props.onSubmit, onCancel = props.onCancel;
    var setPrice = function (price) { return onChange(__assign(__assign({}, values), { price: price })); };
    var setCondition = function (condition) { return onChange(__assign(__assign({}, values), { condition: condition })); };
    var setStatus = function (status) { return onChange(__assign(__assign({}, values), { status: status })); };
    var setSalePoint = function (salePoint) { return onChange(__assign(__assign({}, values), { salePoint: salePoint })); };
    var isValid = values.price !== ''
        && Number(values.price) >= 0
        && Number(values.price) <= 9999
        && !!values.condition
        && !!values.status
        && !!values.salePoint;
    return React.createElement("form", { className: "vertical classified-edit-form", onSubmit: function (event) {
            event.preventDefault();
            if (!isSaving && isValid) {
                onSubmit(buildUpdateRequest(values));
            }
        } },
        error && React.createElement("p", { role: "alert", className: "form-error" }, error),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "edit-price" }, "Pris"),
            React.createElement("input", { id: "edit-price", name: "price", type: "number", min: 0, max: 9999, required: true, value: values.price, disabled: isSaving, onChange: function (event) { return setPrice(event.target.value); } })),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "edit-condition" }, "Tilstand"),
            React.createElement("select", { id: "edit-condition", name: "condition", required: true, value: values.condition, disabled: isSaving, onChange: function (event) { return setCondition(event.target.value); } },
                React.createElement("option", { value: "", disabled: true }, "Velg tilstand"),
                conditionOptions.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "edit-status" }, "Status"),
            React.createElement("select", { id: "edit-status", name: "status", required: true, value: values.status, disabled: isSaving, onChange: function (event) { return setStatus(event.target.value); } },
                React.createElement("option", { value: "", disabled: true }, "Velg status"),
                selectableStatusOptions.map(function (option) { return (React.createElement("option", { key: option.value, value: option.value }, option.label)); }))),
        React.createElement("div", { className: "form-field" },
            React.createElement("label", { className: "field-label", htmlFor: "edit-sale-point" }, "Salgssted"),
            React.createElement(SalePointSelectField, { title: "Salgssted", name: "edit-sale-point", currentValue: values.salePoint, salePoints: salePoints, disabled: isSaving, onChange: function (event) { return setSalePoint(event.target.value); }, onBlur: function () { return undefined; } })),
        React.createElement("div", { className: "horizontal nowrap" },
            React.createElement("button", { type: "submit", className: "button", disabled: isSaving || !isValid }, isSaving ? 'Lagrer...' : 'Lagre'),
            React.createElement("button", { type: "button", className: "is-flat-link", disabled: isSaving, onClick: onCancel }, "Avbryt")));
};
export default ClassifiedEditForm;
